import React from 'react';
import PropTypes from 'prop-types';
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';

/**
 * App Table Component - Wrapper for MUI Table
 * @component
 * @param {Object} props - Component props
 * @returns {React.ReactElement} AppTableComponent
 */
const AppTableComponent = ({
  children,
  sx,
  ...props
}) => {
  // Return/rendering
  return (
    <MuiTable sx={sx} {...props}>
      {children}
    </MuiTable>
  );
};

AppTableComponent.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object
};

// Export sub-components for convenience
export const AppTableContainer = React.forwardRef(({ children, sx, ...props }, ref) => (
  <TableContainer component={Paper} sx={sx} ref={ref} {...props}>
    {children}
  </TableContainer>
));

export const AppTableHead = ({ children, sx, ...props }) => (
  <TableHead sx={sx} {...props}>
    {children}
  </TableHead>
);

export const AppTableBody = ({ children, sx, ...props }) => (
  <TableBody sx={sx} {...props}>
    {children}
  </TableBody>
);

export const AppTableRow = ({ children, sx, onClick, ...props }) => (
  <TableRow sx={sx} onClick={onClick} {...props}>
    {children}
  </TableRow>
);

export const AppTableCell = ({ children, sx, ...props }) => (
  <TableCell sx={sx} {...props}>
    {children}
  </TableCell>
);

AppTableContainer.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object
};

AppTableHead.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object
};

AppTableBody.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object
};

AppTableRow.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
  onClick: PropTypes.func
};

AppTableCell.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object
};

export default AppTableComponent;

